<template>
    <v-lazy
      :options="{
        threshold: 0.5,
      }"
      class="selection-lazy"
    >
      <div class="card flex" style="height: 100%">
        <img class="card-img" :src="item.img.url" alt="photo" />
        <div class="description flex">
          <div class="description__basic">
            <h2 class="title">{{ item.title }}</h2>
            <p class="address">{{ item.address }}</p>
            <p class="price">
              <b class="full-price"
                ><span class="full-price">{{ item.currency.id }}</span
                >{{ item.fullPrice }}</b
              >
              <template v-if="!item.landArea">
                <template v-if="item.typeDeal == 'Аренда'">
                  <span class="gray-text">/мес.</span>
                </template>
                <template v-else>
                  <span class="gray-text"> {{ item.squarePrice }}</span>
                  <span class="gray-text"> {{ item.currency.text }} за м2</span>
                </template>
              </template>
            </p>
            <div class="characters-block flex">
              <div class="characters characters__area flex">
                <span class="gray-text characters__text">{{ item.square }}</span>
                <span class="gray-text">м2</span>
              </div>
              <div
                class="characters characters__area flex"
                v-show="item.landArea"
              >
                <span class="gray-text characters__text">{{
                  item.landArea
                }}</span>
                <span class="gray-text">сот.</span>
              </div>
              <div class="characters characters__height flex">
                <span class="gray-text characters__text">{{
                  item.heightCeiling
                }}</span>
                <span class="gray-text">м</span>
              </div>
              <div class="characters characters__bedroom flex">
                <span class="gray-text characters__text">{{ item.bedroom }}</span>
                <span class="gray-text"> спальни</span>
              </div>
              <div class="characters characters__floor flex">
                <span class="gray-text characters__text">{{ item.floor }}</span>
                <span class="gray-text"> этаж</span>
              </div>
              <div class="characters characters__wc flex">
                <span class="gray-text characters__text">{{ item.wc }}</span>
                <span class="gray-text"> санузла</span>
              </div>
              <div class="characters characters__otd flex">
                <span class="gray-text characters__text">{{ item.otc }}</span>
              </div>
            </div>
            <br />
          </div>
          <div class="id-block flex">
            <b class="ident">ID: {{ item.id }}</b>
            <b class="ident" v-show="item.archive != 'CRM'">{{ item.archive }}</b>
            <b class="ident">{{ item.status }}</b>
          </div>
        </div>
      </div>
    </v-lazy>
  </template>
  
  <script>
  export default {
    name: "Card-Component",
    props: {
      item: Object,
      modelValue: Boolean,
    },
    emits: ["update:modelValue"],
    data() {
      return {
        selected: false,
      };
    },
    watch: {
      selected(val) {
        this.$emit("update:modelValue", val);
      },
    },
  };
  </script>
  
  <style scoped>
  .card {
    position: relative;
  }
  .checkbox_block {
    position: absolute;
    top: 15px;
    right: 0;
  }
  .checkbox_label {
    padding: 0;
    margin: 0;
  }
  .card__block {
    flex-direction: column;
  }
  .card-img {
    width: 100%;
    height: 50%;
  }
  
  .description {
    flex-direction: column;
    padding: 12px;
    height: 50%;
  }
  .description__basic {
    height: 90%;
  }
  .characters-block {
    flex-wrap: wrap;
  }
  .id-block {
    justify-content: space-between;
  }
  .status-block {
    flex-direction: row;
  }
  .selection-lazy {
      min-height: 200;
      transition: fade-transition;
    }
  @media (min-width: 600px) {
    .selection-lazy {
      max-height: 200px;
      transition: fade-transition;
    }
    .card {
      width: 100%;
      flex-direction: row;
      cursor: pointer;
    }
    .card-img {
      width: 25%;
      height: 100%;
    }
  
    .description {
      flex-direction: row;
      flex: auto;
      justify-content: space-between;
      padding: 12px;
      height: 50%;
    }
    .description__basic {
      height: 90%;
    }
    .characters-block {
      flex-wrap: wrap;
    }
    .id-block {
      flex-direction: column;
    }
  }
  </style>  